import React from 'react';
import { RED, INK, GREY, LIGHT, BORDER, FONT, wrap, btnRed, Hero, Crumbs, CtaBand } from '../seo/SeoUI';

function SeoServiceHub({ hub }) {
  const cities = hub.cities || [];

  return (
    <div style={{ fontFamily: FONT, color: INK, background: '#fff' }}>
      <Hero
        breadcrumb={<Crumbs items={[{ label: 'Home', href: '/' }, { label: hub.serviceName }]} />}
        title={`${hub.serviceName} near you`}
        subtitle={hub.serviceTagline || /* COMPLIANCE: background-check claim is intentional (founder confirms BestHand performs background checks). LEGAL_REVIEW_REQUIRED before prod. */ `Trusted, background-checked ${hub.serviceName.toLowerCase()} pros.`}
        badges={[/* COMPLIANCE: background-check claim is intentional (founder confirms BestHand performs background checks). LEGAL_REVIEW_REQUIRED before prod. */ 'Background-checked pros', 'Upfront pricing', 'Satisfaction guarantee']}
      >
        <a href="/category?type=all" style={btnRed}>Get a free estimate</a>
      </Hero>

      <section style={{ ...wrap, padding: '46px 20px 16px' }}>
        <h2 style={{ fontSize: 28, fontWeight: 800, margin: '0 0 8px' }}>{hub.serviceName} by city</h2>
        <p style={{ fontSize: 16, color: GREY, margin: '0 0 26px' }}>
          {cities.length > 0
            ? `Choose your city to book ${hub.serviceName.toLowerCase()} with a local pro.`
            : `We're expanding fast — ${hub.serviceName.toLowerCase()} is coming to more cities soon.`}
        </p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 12 }}>
          {cities.map((c) => (
            <a key={c.path} href={c.path} style={{ display: 'block', background: '#fff', borderRadius: 12, padding: '14px 16px', textDecoration: 'none', color: INK, border: `1px solid ${BORDER}` }}>
              <span style={{ fontWeight: 600 }}>{hub.serviceName} in {c.cityName}</span>
              <span style={{ display: 'block', fontSize: 13, color: GREY, marginTop: 2 }}>{c.cityName}, {c.stateCode}</span>
            </a>
          ))}
        </div>
      </section>

      <div style={{ height: 40 }} />
      <CtaBand title="Ready to get started?" subtitle="Get matched with a trusted local pro in minutes." ctaText="Get started" ctaHref="/category?type=all" />
    </div>
  );
}

export default SeoServiceHub;
